import { TThunkAction } from '../../../../common/types/thunk';
import { selectConfigValue } from '../../../selectors/config';
import { sleep } from '../../../../common/utils/sleep';
import { loadPublishTerms } from '../../publishTerms/loadPublishTerms';
import { checkServiceAfterCheckPaymentStatus } from '../../../actions/checkoutInfo';
import { setPaymentProcessingStatus } from '../../../actions/paymentProcessing';
import { EPaymentStatus, EPaymentType } from '../../../types/reducers/paymentProcessing';

interface IParams {
  type: EPaymentType;
  status: EPaymentStatus;
}

export const processPaymentStatusThunk =
  (params: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const { type, status } = params;

    const isSuccess = status === EPaymentStatus.Succeeded;

    if (!isSuccess) {
      dispatch(setPaymentProcessingStatus(params));

      return;
    }

    const state = getState();
    const loadPublishTermsTimeout = selectConfigValue('loadPublishTermsAfterBuyPackageTimeout')(state);

    if (type === EPaymentType.Package) {
      await sleep(loadPublishTermsTimeout);

      await dispatch(loadPublishTerms());
    }

    dispatch(checkServiceAfterCheckPaymentStatus());
    dispatch(setPaymentProcessingStatus({ type, status: null }));
  };
